/**
 * Carousel snippet
 *
 * @class Snippet_Carousel
 * @extends Snippet
 */

Snippet_Carousel = ( function( Snippet ) {

	var Snippet_Carousel = function() {
		this.construct.apply( this, arguments );
	};

	function createYearDuration(year, duration) {
		var yearDuration = '';
		if (year) {
			yearDuration += '( ' + year + ' ) ';
		}
		
		if(duration) {
			yearDuration += duration + ' ' + __('min');
		}
		return yearDuration;
	}

	$.extend( true, Snippet_Carousel.prototype, Snippet.prototype, {
		/**
		 * @inheritdoc Snippet#init
		 */
		init: function( parent, config ) {
			this.loadedImages = 0;
			this.uid = 'carousel';
			this.collection = config.collection;
			this.imageSizes = config.imageSizes;
			this.items = this.collection.models || [];
			this.collectionsLabels = config.collectionsLabels || false; // update labels to look as on collection
			this.assetsVisible = config.assetsVisible || 4; // how much assets visible
			this.config.assetsFocusableArray = config.assetsFocusableArray || false;
			this.neverEnding = config.neverEnding || false;
			this.title = config.title || '';
			this.target = config.target || '';
			this.category = config.category || {};
			this.seeAll = config.seeAll;
			this.randomly = config.randomly || false; // shake the collection
			this.maxItems = config.maxItems || false; // optional maximum items in carousel

			this.focusArrayInited = false;

			this.from = 0;

			this.$lastFocused = null;
			this.$el = null;
			this.$ul = null;

			this.activated = false;
		},

		/**
		 * @inheritdoc Snippet#create
		 */
		create: function() {
			return $( this.config.el );
		},

		/**
		 * @inheritdoc Snippet#render
		 */
		render: function() {
			// console.log( '[SNP CAROUSEL] render' );

			this.initFocusArray();
			this.$lastFocused = null;
			this.$ul = null;
			this.from = 0;

			var scope = this;

			if ( !this.activated ) {
				// random
				var shake = function( o ) {
					for ( var j, x, i = o.length; i; j = Math.floor( Math.random() * i ), x = o[ --i ], o[ i ] = o[ j ], o[ j ] = x );
					return o;
				};

				if ( this.randomly ) {
					this.collection.models = shake( this.collection.models );
				}

				if ( this.maxItems && this.maxItems < this.collection.length ) {
					this.collection.models = this.collection.models.slice( 0, this.maxItems );
					this.collection.length = this.maxItems;
				}

				this.items = _.clone( this.collection.models );
				this.collection = _.clone( this.collection )

				this.activated = true;
				// console.log( 'SHAKING' );
			}

			// make html
			var html = this.makeContainer();
			this.$el = $( html );
			// assign arrows elements
			this.$leftArrow = $( 'div.nav-left', this.$el );
			this.$rightArrow = $( 'div.nav-right', this.$el );
			// hide left arrow
			if ( !this.config.neverEnding ) {
				this.$leftArrow.addClass('hide');
			}

			if (!this.config.neverEnding && this.assetsVisible >= this.collection.length) {
				this.$leftArrow.remove();
				this.$rightArrow.remove();
			}

			$( this.target ).append( this.$el );

			// if no data are loaded
			if ( 0 === this.collection.length ) {
				console.log( '[SNP CAROUSEL] no data' );
			} else {

				// make elements
				var j = 0;
				var divCounter = 0;

				var html = '';
				for ( var i = 0; i < this.assets; i++ ) {

					j = i;

					// if the slider is neverending we must to repat
					if ( this.neverEnding && i >= this.collection.length ) {
						j = i % this.collection.length;
					}

					// if the slider is ending, then prepend empty div
					if ( !this.neverEnding && 0 == j ) {
						html += this.makeElement( -2, divCounter, true );
						html += this.makeElement( -1, divCounter, true );
						divCounter += 2;
					}

					if ( this.collection.at( j ) ) {
						var $li = $(this.makeElement(j, divCounter));
						this.updateElement($li, j );
						html += $li[0].outerHTML;
					}

					j += 1;
					divCounter += 1;

				}

				this.$ul = $('.movies ul', this.$el);
				this.$ul.empty();
				this.$ul.html(html);

				// update style focusable
				this.updateFocus();

				// if the snippet is ending add class to ul
				if ( !this.neverEnding ) {
					this.$el.addClass( 'ending' );
				}
			}

			// show arrows?
			this.showArrows( ( this.collection.length > _.without( this.assetsFocusableArray, 0 ).length ) );

			this.$el.show();

		},

		initFocusArray: function() {
			if ( this.focusArrayInited ) {
				return;
			}

			// assign or make focusable array
			// visible focusable pattern - example: [0, 1, 0] - for 3 length slider
			this.assetsFocusableArray = this.config.assetsFocusableArray ? this.config.assetsFocusableArray.slice() : Array.apply( null, Array( this.assetsVisible ) ).map( Number.prototype.valueOf, 1 );

			this.assets = this.assetsVisible + 2; // how much assets

			// make focus index array
			if ( this.assetsVisible > this.collection.length || !this.config.assetsFocusableArray ) {
				if ( !this.neverEnding ) {
					// for slider with see all button we must add +1 for collection.length
					this.assetsFocusableArray = Array.apply( null, Array( this.collection.length + ( this.seeAll ? 1 : 0 ) ) ).map( Number.prototype.valueOf, 1 );
					this.assetsFocusableArray.unshift( 0 );
				}
			}

			// add works divs
			//if (this.collection.length > this.assetsVisible) {
			this.assetsFocusableArray.unshift( 0 );
			this.assetsFocusableArray.push( 0 );
			//}

			// inited
			this.focusArrayInited = true;

		},

		// make ul container
		makeContainer: function() {

			var container = '';
			container += '<div class="snippet-slider">';
			container += '	<div class="slider-title">{0}</div>'.format( this.title || '' );
			container += '	<div class="movies"><ul></ul></div>';
			container += '	<div class="preventFocus-left"></div>';
			container += '	<div class="preventFocus-right"></div>';
			container += '	<div class="nav-left clickable" data-id="left"></div>';
			container += '	<div class="nav-right clickable" data-id="right"></div>';
			container += '</div>';

			return container;

		},

		// make li element
		makeElement: function( counter, divCounter, empty ) {

			empty = empty || false;

			var element = '';
			element += ( '<li data-liid="{0}" data-id="{0}" data-counter="{0}" class="empty invisible">' +
				'	<div class="cover">' +
				'		<div class="image" style="background-image: url(\'\');"></div>' +
				'		<div class="label-wrapper">' +
				'			<div class="type"></div>' +
				'			<div class="title-rating-row">' +
				'				<div class="title"></div>' +
				//'				<div class="year-duration"></div>' +
				//'				<div class="description"></div>' +
				'			</div>' +
				'		</div>' +
				'	</div>' +
				'</li>' ).format(
				counter
			);

			return element;

		},


		// update li element
		updateElement: function( $li, counter ) {

			var empty = ( 0 <= counter && counter < this.collection.length ) ? false : true;
			var collectionItem = this.collection.at(counter);
			// add remove class
			$li.toggleClass( 'empty', ( empty ) ? true : false );
			$li.toggleClass( 'invisible', ( empty ) ? true : false );

			// ids
			$li.attr( 'data-id', ( ( empty ) ? '' : collectionItem.getId() ) );
			$li.attr( 'data-counter', counter );

			// image
			var url = ((empty) ? '' : (collectionItem.getCarouselImage() ? collectionItem.getCarouselImage() : 'none'))

			if (this.loadedImages < this.assetsVisible + 2) {
				var img = new Image();
				img.onload = function () {
					++this.loadedImages;
					if (this.loadedImages === this.assetsVisible+2) {
						this.trigger('imagesloaded');
					}
				}.bind(this)
				img.src = url;
			}
			$( 'div.image', $li ).css( {
				'background-image': 'url(\'' + url + '\')'
			} );

			// title
			$( 'div.title', $li ).html( ( ( empty ) ? '' : collectionItem.getTitle() ) );

			// year and duration
			//$('.year-duration', $li).html(empty ? '' : createYearDuration(collectionItem.getYear(), collectionItem.getDuration()));

			// description
			//$('div.description', $li).html(((empty) ? '' : collectionItem.getDescription()));
			return !empty;
		},

		/**
		 * @inheritdoc Snippet#focus
		 */
		focus: function() {
			//console.log( '[SNP CAROUSEL] focus' );
			var $el = this.$lastFocused || $( 'li.focusable', this.$el ).first();
			return Focus.to( $el );
		},

		/**
		 * @inheritdoc Snippet#navigate
		 * Handle navigation within the snippet
		 */
		navigate: function( direction ) {
			// console.log( '[CAROUSEL] navigate ' + direction );
			if ( direction == 'right' ) {
				this.onRight();
				return false;
			} else if ( direction == 'left' ) {
				this.onLeft();
				return false;
			} else if ( direction == 'up' ) {
				this.onUp();
				return false;
			} else if ( direction == 'down' ) {
				this.onDown();
				return false;
			}
		},

		onRight: function() {
			var $newFocus = Focus.focused.nextAll( '.focusable' );

			if ( $( $newFocus ).index() != -1 && $( $newFocus ).index() ) {
				Focus.to( $newFocus );
			} else { // try to scroll right
				this.move( +1, true )
					.bind(this)
					.then( function() {
						this.onRight();
					})
					.catch( function() {
						this.trigger( 'focus:out', this, 'right' );
					});
			}

			return false;
		},

		onLeft: function() {
			var $newFocus = Focus.focused.prevAll( '.focusable' );

			if ( $( $newFocus ).index() != -1 ) {
				Focus.to( $newFocus );
				return true;
			} else { // try to scroll left
				this.move( -1, true )
					.bind(this)
					.then( function() {
						this.onLeft();
					})
					.catch( function() {
						this.trigger( 'focus:out', this, 'left' );
					});
			}

			return false;
		},

		onUp: function() {
			this.trigger( 'leave:up' );
			this.trigger( 'focus:out', this, 'up' );
			return false;
		},

		onDown: function() {
			this.trigger( 'leave:down' );
			this.trigger( 'focus:out', this, 'down' );
			return false;
		},

		onFocus: function( $el ) {
			this.$lastFocused = $el;
			this.parent.hideUpArrow();
			this.parent.$lastFocused = $el;
			// added for kinetic/mouse control support
			this.showArrows(true);
			var focusedRow = this.parent.smallCarouselsGrid.getFocusedRow();	// homeScene.smallCarousel....
			focusedRow && focusedRow.showArrows(false);
		},

		/**
		 * @inheritdoc Snippet#onClick
		 * Call onEnter() on focused element
		 */
		onClick: function( $el, e, stop ) {
			e.stopPropagation();
			return this.onEnter( $el, e, stop );
		},

		/**
		 * @inheritdoc Snippet#onScroll
		 */
		onScroll: function($el, delta, e, stop) {
			if (delta > 0) {
				this.move(-1, true);
			} else {
				this.move(+1, true);
			}
		},

		/**
		 * Event called after Enter is pressed
		 * @param {Object} $el jQuery object of element on enter was triggered
		 * @param {Object} e HTML event
		 * @param {Function} stop Stop function
		 */
		onEnter: function( $el, e, stop ) {
			var scope = this;
			var dataId = $el.attr( 'data-id' );

			if ( 'right' == dataId ) {
				this.move( +1, true ).then( function( isEnd ) {
					// focus last focusable item
					Focus.to( $( 'li.focusable', scope.$el ).last() );
				} );
			} else if ( 'left' == dataId ) {
				this.move( -1, true ).then( function() {
					// focus first focusable item
					Focus.to( $( 'li.focusable', scope.$el ).first() );
				}).catch(function(err) {
				});
			} else {
				App.throbber( false );
				// find item in collection
				var item = this.collection.getById( dataId );

				if ( item.isFetched() ) {
					Router.go( 'detail', item.get('id') );
				} else {
					App.throbber();
					item.fetch()
						.then( function() {
							Router.go( 'detail', item.get('id') );
						})
						.catch( function(err) {
							console.log(err);
						});
				}
			}

			return false;
		},

		/**
		 * Test focusable
		 */
		isFocusable: function() {
			return this.getFocusable().length ? true : false;
		},

		clear: function() {
			//alert( '[SNP CAROUSEL] clear' );
			this.$lastFocused = null;
			this.from = 0;
			this.$el.html( '' );
			this.$el.hide();
		},

		move: function( direction ) {
			return new Promise(function(resolve, reject) {
				this.trigger( 'scrolling', this );

				var $items = $( 'li', this.$ul );

				// are there not so many assets?
				if ( !this.neverEnding && this.collection.length <= this.assetsVisible ) {
					reject();
					return;
				}

				// count from
				this.from += direction;

				var cols = this.assetsVisible;
				var isEnd = false;

				// is set seeAll and count is bigger then seeAllLimit
				// count of focusable items
				var arrayCount = this.assetsFocusableArray.filter( function( value ) {
					return value === 1;
				} ).length;

				if ( !this.neverEnding && ( this.from + cols + ( arrayCount == cols ? 1 : 0 ) > this.collection.length + 1 ) ) {
					isEnd = true;
				}

				// hide right arrow
				if ( !this.neverEnding && ( this.from + cols + direction > this.collection.length ) ) {
					this.$rightArrow.addClass('hide');
				} else {
					this.$rightArrow.removeClass('hide');
				}

				// for neverending carousels
				if ( this.neverEnding ) {

					if ( this.from >= this.collection.length + 1 ) {
						this.from = 1;
					} else if ( this.from < 0 ) {
						this.from = this.collection.length - 1;
					}

				} else if ( this.from < 0 || isEnd ) {

					this.from -= direction;
					reject( isEnd );
					return;
				}

				var dataCounter = ( direction > 0 ) ? ( parseInt( $( 'li', this.$ul ).last().attr( 'data-counter' ), 10 ) + 1 ) : ( parseInt( $( 'li', this.$ul ).first().attr( 'data-counter' ), 10 ) - 1 );
				if ( this.neverEnding ) {
					if ( dataCounter > this.collection.length - 1 ) {
						dataCounter = 0;
					} else if ( dataCounter < 0 ) {
						dataCounter = this.collection.length - 1;
					}
				}

				if ( direction > 0 ) {
					var $li = $items.first();
					// effect animate
					this.animate = false;
					$li.insertAfter( $items.last() );

					// show/hide left/right arrow
					this.$leftArrow.removeClass('hide');
					if ( this.$ul.hasClass( 'right' ) ) {
						this.$ul.removeClass();
						this.$ul.addClass( 'right-sec' );
					} else {
						this.$ul.removeClass();
						this.$ul.addClass( 'right' );
					}
					resolve( isEnd );
				} else {
					// add new asset
					var $li = $items.last();
					this.animate = false;
					$li.insertBefore( $items.first() );

					// add init position for the start of slider
					if ( !this.neverEnding && dataCounter < -1 ) {
						this.$ul.removeClass();
						this.$ul.addClass( 'left-init' );
						// hide left arrow
						this.$leftArrow.addClass('hide');
					} else {
						// show right arrow
						this.$rightArrow.removeClass('hide');
						if ( this.$ul.hasClass( 'left' ) ) {
							this.$ul.removeClass();
							this.$ul.addClass( 'left-sec' );
						} else {
							this.$ul.removeClass();
							this.$ul.addClass( 'left' );
						}
					}
					resolve( isEnd );
				}

				this.updateFocus();

				if ( this.updateElement( $li, dataCounter ) ) {
					$li.removeClass( 'invisible' );
				} else if ( !this.neverEnding ) {
					$li.addClass( 'invisible' );
				}

				// + 2
				if ( !this.neverEnding ) {
					if ( direction > 0 && ( dataCounter + 2 ) >= this.collection.length && this.collection.length < this.collection.getTotalCount() ) {
						this.parent.trigger( 'incremental.loading', this );
					}
				}
			}.bind(this));
		},

		/**
		 * show/hide arrows
		 * @param {Boolean} - hide/show
		 */
		showArrows: function( show ) {
			if (this.neverEnding)
				this.$el.find('[class*="nav-"]').removeClass('hide');
			else if ( show ) {
				var index = this.$el.find('li.focusable').first().attr('data-counter');
				if (index > 0) {
					this.$el.find('.nav-left').removeClass('hide');
				}
				if (index+this.assetsVisible < this.collection.length) {
					this.$el.find('.nav-right').removeClass('hide');
				}
			} else {
				this.$el.find('[class*="nav-"]').addClass('hide');
			}
		},

		updateFocus: function() {
			var scope = this;

			$items = $( 'li', this.$ul );
			$items.removeClass( 'focusable' );

			for ( var i = 0; i < $items.length; i++ ) {
				if ( this.assetsFocusableArray[ i ] && !$( $items[ i ] ).hasClass( 'empty' ) ) {
					$( $items[ i ] ).addClass( 'focusable' );
				}
			}
		},

		/**
		 * store selected/focused home big image
		 */
		storeFocused: function() {
			console.log( 'STORE FOCUSED' );
			// store selected asset
			this.parent.goBack = {};
			this.parent.goBack.focusedId = this.imageSelected;
			// is focused
			this.parent.goBack.hasFocus = this.hasFocus();
		},

		/**
		 * clear class for right and left
		 */
		removeClass: function() {
			this.$ul.removeClass( 'left' ).removeClass( 'right' );
		},

		/**
		 * is focus inside this snippet?
		 */
		focusIsIn: function() {
			return Focus.isIn( this.$el );
		},

		/**
		 * get top css position of the snippet
		 */
		getTop: function() {
			return this.$el.offset().top;
		}

	} );

	return Snippet_Carousel;

} )( Snippet );



//////////////////
// WEBPACK FOOTER
// ./js/snippet/carousel.js
// module id = 60
// module chunks = 0